import React, { useState } from 'react';
import { AuthLayout, ButtonBlockPrimary, InputTextblock } from '../components';
import { useNavigate } from 'react-router-dom';
import { forgetPassword, resetPassword } from '../service/authService';
import { showMessage } from '../utls/message';

const ForgetPassword = () => {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const onSubmit = async () => {

        if (email !== "") {
            const data = {
                email: email
            }
            const response = await forgetPassword(data);
            if (!response.error && response.code === 200) {
                const otp = response.data.otp;
                navigate(`/activation/reset-password/${otp.uniqueId}`)
            } else {
                showMessage(response.message, 'error')
            }

        } else {
            showMessage('Email wajib di isi', 'error')
        }
    }

    return (
        <AuthLayout title='Forget Password'>
            <div className='py-5'>
                <div className="w-full flex justify-center mt-20">
                    <img src="/assets/imgs/icon-forget.png" alt="" />
                </div>
                <div className="w-full justify-center text-center my-5">
                    <h2 className="text-[20px] font-bold">Masukan Email Anda</h2>
                    <h4 className="text-[12px]">Halaman ini adalah langkah pertama untuk <br /> mengakses akun Anda</h4>
                </div>
                <InputTextblock value={email} onChange={(e) => { setEmail(e.target.value) }} placeholder='Masukan alamat email anda' />
                <div className='my-4'>
                    <ButtonBlockPrimary onClick={() => {
                        onSubmit()
                    }}
                        label='Kirim' />
                </div>
            </div>
        </AuthLayout>
    );
};

export default ForgetPassword;